var _ShortCutFormatter_map;
import { __classPrivateFieldGet } from "tslib";
import { capitalize } from '../lodash';
import { isMac } from '../utils/platform';
import { cmChars } from './chars';
import { ModKey as MK } from './const';
class ShortCutFormatter {
    constructor() {
        _ShortCutFormatter_map.set(this, new Map());
    }
    set(name, defs) {
        if (Array.isArray(defs)) {
            __classPrivateFieldGet(this, _ShortCutFormatter_map, "f").set(name, defs);
        }
        else {
            const platformedDefs = defs[isMac() ? 'mac' : 'pc'];
            if (platformedDefs) {
                __classPrivateFieldGet(this, _ShortCutFormatter_map, "f").set(name, platformedDefs);
            }
        }
        return this;
    }
    toPM(name) {
        const defs = __classPrivateFieldGet(this, _ShortCutFormatter_map, "f").get(name);
        if (!defs)
            return null;
        return defs.join('-');
    }
    toCM(name) {
        const defs = __classPrivateFieldGet(this, _ShortCutFormatter_map, "f").get(name);
        if (!defs)
            return null;
        return defs
            .map((str) => { var _a; return (_a = cmChars[str]) !== null && _a !== void 0 ? _a : str; })
            .sort((a) => (a === MK.Shift ? -1 : 0))
            .map(capitalize)
            .join('-');
    }
    toView(name) {
        const defs = __classPrivateFieldGet(this, _ShortCutFormatter_map, "f").get(name);
        return defs === null || defs === void 0 ? void 0 : defs.join('+');
    }
}
_ShortCutFormatter_map = new WeakMap();
export const formatter = new ShortCutFormatter();
